import { BodyLink } from '@jouzen/ecom-components/v3/BodyLink';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import type { ReactNode } from 'react';

import RichText from '@/app/components/RichText';

const tValue = {
  a: function a(chunks: ReactNode) {
    return (
      <BodyLink
        href="mailto:press@ouraring.com"
        color="blue-200"
        className="text-blue-200"
      >
        {chunks}
      </BodyLink>
    );
  },
};

const link = (chunks: ReactNode) => {
  return (
    <BodyLink
      aria-label="Newsroom Media Assets"
      href="https://drive.google.com/drive/folders/1kDpHp2pBc4dhiSZPPNJR6OkqHzi4u6AS"
      target="_blank"
      color="blue-200"
    >
      {chunks}
    </BodyLink>
  );
};

export const NewsroomContactUs = () => {
  return (
    <LayoutGrid>
      <GridItem
        colEnd={{ sm: 'main', lg: 19 }}
        colStart={{ sm: 'main', lg: 9 }}
        className="mb-24"
        data-cy="newsroom-contact-us"
      >
        <Typography variant="h6" weight="normal">
          <RichText messageKey="press_content_heading" tValues={tValue} />
        </Typography>
        <Typography className="mt-4" variant="h6" weight="normal">
          <RichText messageKey="press_media_assets" tValues={{ link }} />
        </Typography>
      </GridItem>
    </LayoutGrid>
  );
};
